import { StyledDivider } from './Divider.styled';
import type { DividerProps } from './Divider.types';

export const Divider = ({
  orientation = 'horizontal',
  width = '100%',
  height = '100%',
  thickness = 1,
  ...props
}: DividerProps) => {
  return (
    <StyledDivider
      height={height}
      orientation={orientation}
      thickness={thickness}
      width={width}
      {...props}
    />
  );
};
